import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CountryLookupEnum, ShippingContactTypeNameEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { LeadAccountAddFormComponent } from '../lead-account-add-form/lead-account-add-form.component';

@Component({
    selector: 'app-full-account-confirmation',
    templateUrl: './full-account-confirmation.component.html',
    styleUrls: ['./full-account-confirmation.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FullAccountConfirmationComponent implements OnInit {

    @Output() emitUpdatedPayerDetails = new EventEmitter<any>();
    ordersDataModel = new CommonDataModel();
    shippingContactTypeNameEnum = ShippingContactTypeNameEnum;
    countryLookupEnum = CountryLookupEnum;
    quickContactEditForm: any = this.ordersDataModel.quickContactEditModel;
    countries: any;
    commonConstants = CommonConstants;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialog,
        private commonService: CommonService,
        private contactService: ContactService,
        private commonMethod: CommonMethod,
        private dialogRef: MatDialogRef<FullAccountConfirmationComponent>
    ) {
        if (data && data.payerDetails && data.payerDetails.contactId) {
            this.fetchContactDetails(data.payerDetails.contactId);
        }
    }

    ngOnInit(): void {
        this.getCountries();
    }

    fetchContactDetails(contactId: number): void {
        this.contactService.editQuickContact(contactId).subscribe(response => {
            if (response.isSuccess) {
                const formattedResponse = this.formatContactData(response.data);
                this.quickContactEditForm = formattedResponse;
            }
        });
    }

    formatContactData(data: any): any {
        const formattedData = this.commonService.getObjectValueAsString(data);
        const countrySelectedId = +formattedData.countryId;
        formattedData.countryId = countrySelectedId;
        formattedData.alternateContacts = data.alternateContacts;
        return formattedData;
    }

    getCountries(): void {
        this.commonService.getCountries().subscribe(response => {
            if (response.isSuccess) {
                this.countries = response.data;
            }
        });
    }

    onConvertToFullLead(): void {
        this.dialogRef.close();
        this.dialog.open(LeadAccountAddFormComponent, {
            position: { right: '0' },
            panelClass: 'small_layout',
            hasBackdrop: false,
            autoFocus: false,
            data: { isQuickAccount: true, editQuickContactEditForm: this.quickContactEditForm }
        }).afterClosed().subscribe((response: any) => {
            if (response) {
                this.getLeadDetails();
            }
        });
    }

    getLeadDetails(): void {
        this.contactService.editQuickContact(this.quickContactEditForm.contactId).subscribe(response => {
            if (response.isSuccess) {
                const formattedResponse = this.formatContactData(response.data);
                formattedResponse.isConvertToLead = true;
                formattedResponse.provinceName = formattedResponse.provinceName;
                const country = this.countries.find(item => item.id === formattedResponse.countryId);
                formattedResponse.countryName = country ? country.countryName : '';
                this.quickContactEditForm = formattedResponse;
                this.commonMethod.sendPayerData(formattedResponse);
                this.onClosePopup();
            }
        });
    }

    onClosePopup(): void {
        this.dialogRef.close();
    }
}